import { PopupRequest, PublicClientApplication } from "@azure/msal-browser";
import enviroments from "../enviroments";

export const config = {
  appId: enviroments.APP_ID,
  redirectUri: window.location.origin,
  clientSecret: enviroments.CLIENT_SECRET,
  scopes: ["user.read", "email", "offline_access"],
  authority: enviroments.AUTHORIY,
};

const config2 = {
  auth: {
    clientId: enviroments.APP_ID || "",
    authority: enviroments.AUTHORIY,
    redirectUri: enviroments.URL_ADMIN,
  },
};

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: config.appId || "",
    redirectUri: config.redirectUri,
    authority: config.authority,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    secureCookies: true,
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
});

export const refreshTokenAzure = async () => {
  const pca = new PublicClientApplication(config2);

  // Verifique se há uma conta ativa ou chame loginPopup para autenticar o usuário
  const currentAccount = pca.getActiveAccount();
  if (!currentAccount) {
    const request: PopupRequest = {
      scopes: ["Mail.Read"], // A permissão que você deseja solicitar
    };

    try {
      const loginResponse = await pca.loginPopup(request);
      // Defina a conta ativa após a autenticação
      pca.setActiveAccount(loginResponse.account);

      // Agora, você pode obter o token de acesso
      const response = await pca.acquireTokenSilent(request);
      console.log(response);
      return response.accessToken;
    } catch (error) {
      return null;
    }
  } else {
    // Se houver uma conta ativa, você pode obter o token de acesso diretamente
    const request: PopupRequest = {
      account: currentAccount,
      scopes: ["Mail.Read"],
    };

    try {
      const response = await pca.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
};
